import { render, staticRenderFns } from "./zhanzhuye.vue?vue&type=template&id=3f91a50f&scoped=true"
import script from "./zhanzhuye.vue?vue&type=script&lang=js"
export * from "./zhanzhuye.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f91a50f",
  null
  
)

export default component.exports